"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Error = void 0;
var _alert = _interopRequireWildcard(require("@kawaui/alert"));
var _auth = require("@narf/auth");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _errors = require("./utils/errors");
var _hooks = require("./utils/hooks");
var _mixpanel = require("./utils/mixpanel");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved

const authRedirect = () => {
  if (typeof window === 'undefined') return `/authentication/login`;
  return `/authentication/login?ReturnUrl=${encodeURIComponent(window.location.href)}`;
};
const Alert = ({
  open,
  onClose,
  onAccept: onAcceptBase,
  header,
  content,
  button,
  children
}) => {
  const {
    i18n
  } = (0, _hooks.useTranslate)();
  const onAccept = () => {
    onAcceptBase();
    onClose();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_alert.default, {
    open,
    onClose,
    disableBackdropEvents: false,
    children: [header && /*#__PURE__*/(0, _jsxRuntime.jsx)(_alert.Header, {
      children: i18n(header)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alert.Content, {
      children: content ? i18n(content) : children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alert.Footer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_alert.AlertButton, {
        onClick: onAccept,
        children: i18n(button)
      })
    })]
  });
};
Alert.defaultProps = {
  onAccept: () => {},
  header: 'errors.something_failed.modal.title',
  button: 'common.close'
};
const AlertDefault = ({
  open,
  onClose,
  onAccept,
  statusText,
  error
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(Alert, {
  open,
  onClose,
  onAccept,
  children: error.error_description || statusText
});

// TODO(fernando.cervera): block requests until the token is updated
const AlertAuth = ({
  onAccept: onAcceptBase,
  onReAuth,
  ...props
}) => {
  const onAccept = () => {
    (0, _auth.getMember)({
      refetch: true
    }).then(() => onReAuth()).catch(err => {
      onAcceptBase();
      throw err;
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Alert, {
    onAccept: onAccept,
    ...props
  });
};
const Error = ({
  open,
  onClose,
  error,
  status,
  statusText,
  onRouting,
  onReAuth,
  track
}) => {
  const errorCopy = (0, _errors.getWidgetCopy)({
    error,
    status
  });
  (0, _react.useEffect)(() => {
    if (open) track(...(0, _mixpanel.ErrorRender)({
      error,
      statusText,
      status
    }));
  }, [open]);
  const AlertDefaultSimple = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(AlertDefault, {
    open,
    onClose,
    statusText,
    error,
    ...props
  });
  switch (status) {
    case 401:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(AlertAuth, {
        onAccept: () => {
          onRouting(authRedirect());
        },
        open,
        onClose,
        onReAuth,
        ...errorCopy
      });
    default:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(AlertDefaultSimple, {});
  }
};
exports.Error = Error;
Error.propTypes = {
  open: _propTypes.default.bool.isRequired,
  onClose: _propTypes.default.func.isRequired,
  error: _propTypes.default.object.isRequired,
  onRouting: _propTypes.default.func,
  status: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  statusText: _propTypes.default.string,
  track: _propTypes.default.func
};
Error.defaultProps = {
  onClose: () => {},
  error: {},
  onRouting: url => {
    window.location.href = url;
  },
  track: () => {}
};
var _default = exports.default = Error;